export default "__VITE_ASSET__BVROFkXv__"